/**
 * Este enum define os “códigos” (valores) que o backend espera
 * para o status de aprovação. Exatamente: “PENDING”, “APPROVED”, “REJECTED” etc.
 */
export enum TypeApprovalStatus {
    NONE = 'NONE',           // Não definido ou estado inicial
    PENDING = 'PENDING',     // Aguardando aprovação
    APPROVED = 'APPROVED',   // Aprovado
    REJECTED = 'REJECTED',   // Rejeitado
}

/**
 * Mapeia cada valor do enum para o texto que o usuário verá na tela.
 */
export const ApprovalStatusLabel: Record<TypeApprovalStatus, string> = {
    [TypeApprovalStatus.NONE]: '',
    [TypeApprovalStatus.PENDING]: 'Aguardando',
    [TypeApprovalStatus.APPROVED]: 'Aprovado',
    [TypeApprovalStatus.REJECTED]: 'Rejeitado',
};

/**
 * Mapeia cada valor do enum para uma cor padrão a ser usada na UI.
 */
export const ApprovalStatusColor: Record<TypeApprovalStatus, string> = {
    [TypeApprovalStatus.NONE]: '#888888',     // cinza neutro
    [TypeApprovalStatus.PENDING]: '#FFC107',  // amarelo (pendente)
    [TypeApprovalStatus.APPROVED]: '#28A745', // verde (aprovado)
    [TypeApprovalStatus.REJECTED]: '#DC3545', // vermelho (rejeitado)
};
